import { filterEventHandler } from './itemlist';


window.addEventListener('touchmove', () => {});

$(() => {
  if ($('[data-export-definition]').length) {
    import(/* webpackChunkName: "mobile-drag-drop" */ 'mobile-drag-drop').then(({ polyfill }) => {
      polyfill();
    });
  }
});

$(document).on('change', '[data-export-definition] input[name="definition-do_zip"]', function() {
  const exportDefinition = $('[data-export-definition]');
  const fileExt = exportDefinition.attr('data-export-file-ext');
  const filename = exportDefinition.find('input[name="definition-filename"]');
  let fn = filename.val();
  if ($(this)[0].checked) {
    if (!fn.endsWith('.zip')) {
      if (fn.endsWith(fileExt)) {
        fn = fn.substr(0, fn.length - fileExt.length);
        filename.val(`${fn}.zip`);
      }
    }
  } else if (fn.endsWith('.zip')) {
    fn = fn.substr(0, fn.length - 4);
    filename.val(`${fn}${fileExt}`);
  }
});

$(document).on('change.zf.tabs', '.itemlist-nav__dropdown', function() {
  const $current = $(this).find(`.${$(this).find('[data-tabs]').attr('data-link-class')}.is-active`);
  $(`[data-toggle="${$(this).attr('id')}"]`).find('.itemlist-nav__label').text($current.text());
  $(this).foundation('close');
});

let currentField = null;
let currentData = null;
let onFieldFormClose = null;
let onFieldFormSubmit = null;

function createField(data, isActive) {
  const field = $('<div class="export-field" draggable="true"><div><span></span></div></div>')
    .toggleClass('is-active', !!isActive)
    .attr('data-field-id', data.id)
    .attr('data-field-lang', data.lang)
    .attr('data-field-label-template', data.labelTemplate);

  let btn;
  if (data.labelTemplate) {
    btn = $('<button type="button" class="button small clear" data-export-field-edit></button>')
      .append($('<i class="icon icon-edit"></i>'));
    field.find('> div').append(btn);
  }

  btn = $('<button type="button" class="button small clear" data-export-field-delete></button>')
    .append($('<i class="icon icon-delete"></i>'));
  field.find('> div').append(btn).find('> span').text(data.text);

  const i = $('#id_field-TOTAL_FORMS').val();
  field
    .append($(`<input type="hidden" name="field-${i}-id" value="">`))
    .append($(`<input type="hidden" name="field-${i}-definition">`)
      .val($('[data-export-fields-selection]').attr('data-export-definition')))
    .append($(`<input type="hidden" name="field-${i}-field">`).val(data.id))
    .append($(`<input type="hidden" name="field-${i}-lang">`).val(data.lang))
    .append($(`<input type="hidden" name="field-${i}-custom_fields">`).val('{}'))
    .append($(`<input type="hidden" name="field-${i}-pos">`).val(i))
    .append($(`<input type="hidden" name="field-${i}-DELETE">`));
  return field;
}

const preview = window.Foundation.util.debounce(() => {
  filterEventHandler.bind($('[data-export-fields-selection]'))();
}, 500);

function resortHiddenInputs() {
  $('[data-export-fields-selection] [data-field-id]:not(.is-deleted) input[name$="-pos"]').each(function(i) {
    $(this).val(i + 1);
  });
  $('#id_field-TOTAL_FORMS').val($('[data-export-fields-selection] [data-field-id]').length);
  preview();
}

function getOnFieldFormSubmit($fieldFormReveal, field, resort = true) {
  return () => {
    let label = field.attr('data-field-label-template') || '';
    const data = {};
    $.each($fieldFormReveal.serializeArray(), function () {
      data[this.name] = this.value;
      label = label.replace(`[${this.name}]`, this.value);
    });
    field.find('input[name$="-custom_fields"]').val(JSON.stringify(data));
    if (label) {
      field.find('> div > span').text(label);
    }
    if (resort) {
      resortHiddenInputs();
    } else {
      preview();
    }
  };
}

function deleteField(field) {
  $(field).find('input[name$="-DELETE"]').val('1');
  $(field).addClass('is-deleted');
  resortHiddenInputs();
}

$(document).on('dragstart', '[data-export-fields-container] [data-field-id]', function(event) {
  event.originalEvent.dataTransfer.setData('text/plain', $(this).attr('data-field-id'));
  currentData = {
    type: 'field',
    id: $(this).attr('data-field-id'),
    lang: $(this).attr('data-field-lang'),
    labelTemplate: $(this).attr('data-field-label-template'),
    text: $(this).text(),
    isNew: true,
  };
});

$(document).on('dragstart', '[data-export-fields-selection] [data-field-id]', function(event) {
  event.originalEvent.dataTransfer.setData('text/plain', $(this).attr('data-field-id'));
  currentData = {
    type: 'field',
    id: $(this).attr('data-field-id'),
    lang: $(this).attr('data-field-lang'),
    labelTemplate: $(this).attr('data-field-label-template'),
    text: $(this).text(),
    isNew: false,
  };
  currentField = $(this);
});

$(document).on('touch click', '[data-export-fields-container] [data-field-id]', function() {
  const field = createField({
    id: $(this).attr('data-field-id'),
    lang: $(this).attr('data-field-lang'),
    labelTemplate: $(this).attr('data-field-label-template'),
    text: $(this).text(),
  });
  $('[data-export-fields-selection]').append(field);

  const $fieldFormReveal = $(`#custom-field-form-${field.attr('data-field-id')}`);
  if ($fieldFormReveal.length) {
    onFieldFormClose = () => {
      field.remove();
    };
    onFieldFormSubmit = getOnFieldFormSubmit($fieldFormReveal, field);
    $fieldFormReveal.foundation('open');
  } else {
    resortHiddenInputs();
  }
});

$(document).on('dragend', '[data-export-fields-container] [data-field-id]', () => {
  currentData = null;
  if (currentField) {
    currentField.remove();
    currentField = null;
  }
  resortHiddenInputs();
});

$(document).on('dragover', '[data-export-fields-container]', () => {
  if (currentField) {
    currentField.remove();
  }
});

$(document).on('dragenter', '[data-export-fields-selection]', function(event) {
  if (currentData) {
    event.preventDefault();
    if (!currentField) {
      currentField = createField(currentData, true);
    }
    $(this).append(currentField);
  }
});

$(document).on('dragenter', '[data-export-fields-selection] [data-field-id]', function(event) {
  if (currentData) {
    event.preventDefault();
    event.stopPropagation();
    if (!currentField) {
      currentField = createField(currentData, true);
    } else if (currentField.get(0) === this) {
      return;
    }
    currentField.insertBefore($(this));
  }
});

$(document).on('dragover', '[data-export-fields-selection]', (event) => {
  if (currentData) {
    event.preventDefault();
  }
});

$(document).on('drop', '[data-export-fields-selection]', (event) => {
  event.preventDefault();
  if (currentField) {
    if (currentData.isNew) {
      const $fieldFormReveal = $(`#custom-field-form-${currentField.attr('data-field-id')}`);
      if ($fieldFormReveal.length) {
        const field = currentField;
        onFieldFormClose = () => {
          field.remove();
        };
        onFieldFormSubmit = getOnFieldFormSubmit($fieldFormReveal, field);
        $fieldFormReveal.foundation('open');
      } else {
        resortHiddenInputs();
      }
    } else {
      resortHiddenInputs();
    }

    currentField.removeClass('is-active');
    currentField = null;
  }
});

$(document).on('click', '[data-export-field-edit]', function() {
  const field = $(this).closest('[data-field-id]');
  const $fieldFormReveal = $(`#custom-field-form-${field.attr('data-field-id')}`);
  if ($fieldFormReveal.length) {
    try {
      const data = JSON.parse(field.find('input[name$="-custom_fields"]').val());
      $.each(data, (name, value) => {
        $fieldFormReveal.find(`[name="${name}"]`).val(value);
      });
    } catch (e) {
      console.error('Could not parse custom fields data', e);
    }
    onFieldFormClose = null;
    onFieldFormSubmit = getOnFieldFormSubmit($fieldFormReveal, field, false);
    $fieldFormReveal.foundation('open');
  }
});

$(document).on('dblclick', '[data-export-fields-selection] [data-field-id]', function() {
  deleteField(this);
});

$(document).on('click', '[data-export-field-delete]', function() {
  deleteField($(this).closest('[data-field-id]'));
});

$(document).on('closed.zf.reveal', '[data-field-form-reveal]', function() {
  this.reset();
  if (onFieldFormClose) {
    onFieldFormClose(this);
    onFieldFormClose = null;
    onFieldFormSubmit = null;
  }
});

$(document).on('submit', '[data-field-form-reveal]', function(event) {
  event.preventDefault();
  if (onFieldFormSubmit) {
    onFieldFormSubmit(this);
    onFieldFormSubmit = null;
    onFieldFormClose = null;
    $(this).foundation('close');
  }
  this.reset();
});

$(document).on('change', '[data-export-definition][data-itemlist-filter] input[type=text]', filterEventHandler);

$(document).on('click', '.export-copy-button', (event) => {
  $('#export-copy-form').attr('action', $(event.currentTarget).data('export-definition-copy-url'));
});

$(document).on('submit', '#export-copy-form', (event) => {
  const $form = $('#export-copy-form');
  event.preventDefault();
  $.ajax({
    url: $form.attr('action'),
    cache: false,
    contentType: 'application/x-www-form-urlencoded',
    type: 'POST',
    data: $form.serialize(),
    success: () => {
      window.location.reload();
    },
    error: (response) => {
      $('.copy-export-form-container').html(response.responseText);
      $('#export-copy-form').attr('action', $form.attr('action'));
    },
  });
});

$(document).on('click', '.close-copy-export-form', () => {
  const $form = $('#export-copy-form');
  $.ajax({
    url: $form.attr('action'),
    success: (response) => {
      $('.copy-export-form-container').html(response);
    },
    error: () => {
      window.location.reload();
    },
  });
});

$(document).on('click', '[data-edit-export-definition-type]', (event) => {
  const $url = $(event.currentTarget).data('edit-export-definition-type');
  $.ajax({
    url: $url,
    method: 'GET',
    success: (response) => {
      const $formContainer = $(document).find('[data-edit-export-definition-type-container]');
      $formContainer.html(response);
    },
  });
});
